import RegisterModel from './model/registerModel'
import mixins from 'vue-typed-mixins'
import routeMixin from '@/router/routeMixin'
import { Credentials, NativeBiometric } from 'capacitor-native-biometric'
import { Capacitor } from '@capacitor/core'

export default mixins(routeMixin).extend({
    data() {
        return {
            mailMotDePasseOublie: '',
            credentialsBiometrics : null as null | Credentials
        }
    },
    methods: {
        init() {
            this.$auth.logout()
        },
        deleteCredentials() {
            NativeBiometric.isAvailable().then(value => {
                if (value.isAvailable) {
                    NativeBiometric.deleteCredentials({
                        server: 'recette.biobank.id3i.fr'
                    })
                    this.credentialsBiometrics = null
                }
            })
        },
        loginBiometric(){
            if(this.credentialsBiometrics){
                NativeBiometric.verifyIdentity({
                    reason: 'For easy log in',
                    title: 'Log in',
                    subtitle: 'Maybe add subtitle here?',
                    description: 'Maybe a description too?'
                })
                .then(a => {
                    const model = new RegisterModel()
                    // @ts-ignore
                    model.password = this.credentialsBiometrics.password
                    // @ts-ignore
                    model.email = this.credentialsBiometrics.username
                    this.login(model)
                })
            }
        },
        login(model: RegisterModel): Promise<boolean> {
            this.$loader.go()
            return this.$http
                .api('authentification', true)
                .post(model.asLoginModel())
                .then(x => {
                    this.$loader.stop()
                    const login = () => {
                        this.$auth.authentify(x.data.token, x.data.refreshtoken)

                        return this.$http
                            .api('user/current')
                            .get()
                            .then(x => {
                                this.$database.account.feed(x.data)
                                this.$database.save()

                                this.$swal.toast.success()
                                this.navigateToHome()

                                return true
                            })
                            .catch(x => {
                                this.$auth.logout()
                                this.$swal.toast.errorApi(x)
                                return false
                            })
                    }

                    if (Capacitor.getPlatform() != 'web') {
                        return NativeBiometric.isAvailable().then(value => {
                            if (value.isAvailable) {
                                return NativeBiometric.getCredentials({
                                    server: 'recette.biobank.id3i.fr'
                                })
                                    .then(cred => login())
                                    .catch(cred => {
                                        const message =
                                            "Voulez-vous sauvegarder les informations de connexion dans l'application ? Cela permettra de se connecter et de valider certaines actions sensibles via la reconnaissance biométrique de votre appareil (empreinte digitale ou reconnaissance faciale)."
                                        const title = 'Sauvegarde identifiant connexion'
                                        return this.$swal.confirm.yesCancel(title, message, 'Sauvegarder').then(x => {
                                            if (x.isConfirmed) {
                                                NativeBiometric.setCredentials({
                                                    username: model.email,
                                                    password: model.password,
                                                    server: 'recette.biobank.id3i.fr'
                                                })
                                            }
                                            return login()
                                        })
                                    })
                            } else {
                                return login()
                            }
                        })
                    } else return login()
                })
                .catch(x => {
                    this.$swal.toast.errorApi(x)
                    return false
                })
                .finally(() => {
                    this.$loader.stop()
                    return false
                })
        },
        sendMailMotDePasseOublie() {
            this.$http
                .api('account/forgotpassword', true)
                .post({ email: this.mailMotDePasseOublie, baseUrl: this.baseUrl() })
                .then(() => {
                    this.$swal.toast.success('Un email vous a été envoyé avec le lien de re-définition du mot de passe')
                    this.mailMotDePasseOublie = ''
                })
                .catch(x => this.$swal.toast.errorApi(x))
        }
    },
    mounted: function() {
        NativeBiometric.isAvailable().then(value => {
            if (value.isAvailable) {
                NativeBiometric.getCredentials({
                    server: 'recette.biobank.id3i.fr'
                }).then(cred => {
                    this.credentialsBiometrics = cred
                })
            }
        })
    }
})
